import React from "react";

import Login from "../features/login/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
